<template>
  <div id="app">
    <div id="container">
      <nav>
        <router-link to="/">系统大屏</router-link> |

        <router-link to="/System">系统设置</router-link>|
        <router-link to="/JobMonth">工作日历</router-link>|
        <router-link to="/PlanStop">计划停机</router-link>|
        <router-link to="/PlanManufactureTime">理论加工时间</router-link>|
        <router-link to="/Unqualified">不良品</router-link>|
        <router-link to="/MappingTable">映射表</router-link>|
        <router-link to="/About">关于</router-link>
      </nav>
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {

  },
  data() {
    return {}
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

#container {

  width: 1300px;
  margin: auto;

}
</style>
